module.exports = __webpack_public_path__ + "static/media/hr.1e6ff081.png";